import React from "react";
import { FileText, Pencil } from "lucide-react";
import { TRY, trDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function InvoiceDetailDialog({ invoice, partyName, onClose, onEdit }) {
  if (!invoice) return null;
  const lines = invoice.lines || [];
  return (
    <Dialog open={!!invoice} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="invoice-detail">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><FileText className="h-5 w-5 text-primary" /> Fatura Detayı {invoice.invoice_no && <span className="font-mono text-base text-muted-foreground">· {invoice.invoice_no}</span>}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
            <Info l={invoice.supplier_id ? "Tedarikçi" : "Müşteri"} v={partyName} className="col-span-2" />
            <Info l="Fatura Tarihi" v={trDate(invoice.date)} />
            <Info l="Vade" v={invoice.due_date ? trDate(invoice.due_date) : "—"} />
          </div>
          <div className="rounded-lg border border-border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-muted/40 text-[11px] uppercase tracking-wider text-muted-foreground">
                <tr><th className="px-3 py-2 text-left w-8">#</th><th className="px-3 py-2 text-left">Nevi</th><th className="px-3 py-2 text-right">Adet</th><th className="px-3 py-2 text-right">Birim Fiyat</th><th className="px-3 py-2 text-right">KDV</th><th className="px-3 py-2 text-right">Tutar</th></tr>
              </thead>
              <tbody>
                {lines.map((l, i) => (
                  <tr key={i} className="border-t border-border/60" data-testid={`invoice-detail-line-${i}`}>
                    <td className="px-3 py-2 font-mono text-muted-foreground">{i + 1}</td>
                    <td className="px-3 py-2 font-medium">{l.name}</td>
                    <td className="px-3 py-2 text-right font-mono">{Number(l.qty).toLocaleString("tr-TR")}</td>
                    <td className="px-3 py-2 text-right font-mono">{TRY(l.unit_price)}</td>
                    <td className="px-3 py-2 text-right font-mono text-amber-400">%{l.vat_rate} · {TRY(l.vat)}</td>
                    <td className="px-3 py-2 text-right font-mono">{TRY(l.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="ml-auto w-full sm:w-72 space-y-1.5 text-sm" data-testid="invoice-detail-totals">
            <Row l="Ara Toplam" v={TRY(invoice.invoice_net)} />
            <Row l="KDV Toplamı" v={TRY(invoice.invoice_vat)} />
            <div className="border-t border-border pt-2 flex justify-between font-semibold text-base"><span>Genel Toplam</span><span className="font-mono text-primary">{TRY(invoice.amount)}</span></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Kapat</Button>
          {onEdit && <Button onClick={() => { onClose(); onEdit(invoice); }} data-testid="invoice-detail-edit" className="gap-2"><Pencil className="h-4 w-4" /> Düzenle</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

const Info = ({ l, v, className = "" }) => <div className={className}><div className="text-[11px] uppercase tracking-wider text-muted-foreground">{l}</div><div className="font-medium mt-0.5">{v || "—"}</div></div>;
const Row = ({ l, v }) => <div className="flex justify-between"><span className="text-muted-foreground">{l}</span><span className="font-mono">{v}</span></div>;
